<template>
  <div class="app-root">
    <router-view></router-view>
    <!-- global snackbar -->
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn  flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import colors from 'vuetify/lib/util/colors'
import AppEvents from "./event"
export default {
   computed: {
    snackbar(){
      return this.store.state.snackbar
    }
   },
   watch:{
    snackbar: {
      handler: function(oldValue, newValue) {
      },
      deep: true
    },
   },
  data() {
    return {
      rightDrawer: false,
      
    }
  },
  created() {
    // add app events
    // this.$vuetify.theme.primary = "#01579B"
  },
  methods: {
  }
}
</script>

<style scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}
</style>
